import Login from '../views/Login.vue'
import Base from '../views/DashboardBase.vue'
import * as roles from '@/constants/roles'
import store from '@/store'
// import Home from '../views/Home.vue'
const routes = [
  {
    path: '/',
    name: 'Login',
    meta: { requiresAuth: false },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.authenticated) {
        next('/dashboard')
      } else {
        next()
      }
    },
    component: Login
  },
  {
    path: '/dashboard',
    component: Base,
    meta: {
      requiresAuth: true,
      authorize: [roles.SUPER_ADMIN, roles.ADMIN]
    },
    children: [
      {
        path: '',
        name: 'Dashboard',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        component: () => import('@/views/Home.vue')
      },
      // news
      {
        name: 'news-list',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        path: '/news',
        component: () => import('@/views/news/NewsList.vue')
      },
      {
        name: 'news-add',
        path: '/news/add',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        component: () => import('@/views/news/AddNews.vue')
      },
      {
        name: 'news-edit',
        path: '/news/edit/:id',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        props: true,
        component: () => import('@/views/news/EditNews.vue')
      },
      // article
      {
        name: 'article-edit',
        path: '/article/edit/:id',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        props: true,
        component: () => import('@/views/article/EditArticle.vue')
      },
      {
        name: 'article-add',
        path: '/article/add',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        props: true,
        component: () => import('@/views/article/AddArticle.vue')
      },
      {
        name: 'guest-article-list',
        path: '/guest-article',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        props: true,
        component: () => import('@/views/article/ListGuestWriterArticle.vue')
      },
      {
        name: 'public-article-list',
        path: '/public-article',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        props: true,
        component: () => import('@/views/article/ListPublicWriterArticle.vue')
      },
      // guest writer
      {
        name: 'guestwriter-list',
        path: '/guestwriter',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        props: true,
        component: () => import('@/views/guest_writer/ListGuestWriter.vue')
      },
      {
        name: 'guestwriter-edit',
        path: '/guestwriter/edit/:id',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        props: true,
        component: () => import('@/views/guest_writer/EditGuestWriter.vue')
      },
      {
        name: 'guestwriter-add',
        path: '/guestwriter/add',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        props: true,
        component: () => import('@/views/guest_writer/AddGuestWriter.vue')
      },
      {
        name: 'guestwriter-articles',
        path: '/guestwriter/:id/articles',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        props: true,
        component: () =>
          import('@/views/guest_writer/GuestWriterArticleList.vue')
      },
      // headline
      {
        name: 'headlines',
        path: '/headlines',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        props: true,
        component: () => import('@/views/headline/HeadlineList.vue')
      },
      // editorial
      {
        name: 'editorial-edit',
        path: '/editorial/edit/:id',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        props: true,
        component: () => import('@/views/editorial/EditEditorial.vue')
      },
      {
        name: 'editorial',
        path: '/editorial',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        props: true,
        component: () => import('@/views/editorial/ListEditorial.vue')
      },
      {
        name: 'editorial-add',
        path: '/editorial/add',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        props: true,
        component: () => import('@/views/editorial/AddEditorial.vue')
      },
      // vanglaini thlalak
      {
        name: 'vanglaini-thlalak-edit',
        path: '/vanglaini-thlalak/edit/:id',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        props: true,
        component: () =>
          import('@/views/vanglaini_thlalak/EditVanglainiThlalak.vue')
      },
      {
        name: 'vanglaini-thlalak',
        path: '/vanglaini-thlalak',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        props: true,
        component: () =>
          import('@/views/vanglaini_thlalak/ListVanglainiThlalak.vue')
      },
      {
        name: 'vanglaini-thlalak-add',
        path: '/vanglaini-thlalak/add',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        props: true,
        component: () =>
          import('@/views/vanglaini_thlalak/AddVanglainiThlalak.vue')
      },
      // super admin/admin
      {
        name: 'admins',
        path: '/admin-list',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN]
        },
        props: true,
        component: () => import('@/views/super_admin/ListAdmin.vue')
      },
      {
        name: 'super-admin-account',
        path: '/super-admin/account',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN]
        },
        props: true,
        component: () => import('@/views/super_admin/Account.vue')
      },
      // settings
      {
        name: 'settings',
        path: '/settings',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN]
        },
        props: true,
        component: () => import('@/views/settings/Settings.vue')
      },
      // subscriptions & plan
      {
        name: 'plan',
        path: '/plan',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN]
        },
        props: true,
        component: () => import('@/views/subscription_plan/PlansList.vue')
      },
      // user list
      {
        name: 'users',
        path: '/users',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN]
        },
        props: true,
        component: () => import('@/views/user/ListUser.vue')
      },
      {
        name: 'user-edit',
        path: '/user/edit/:id',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN]
        },
        props: true,
        component: () => import('@/views/user/EditUser.vue')
      },

      // Breaking news
      {
        name: 'breaking-news',
        path: '/breaking-news',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        props: true,
        component: () => import('@/views/breaking_news/ListBreakingNews.vue')
      },
      {
        name: 'breaking-news-add',
        path: '/breaking-news/add',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        props: true,
        component: () => import('@/views/breaking_news/AddBreakingNews.vue')
      },
      {
        name: 'breaking-news-edit',
        path: '/breaking-news/edit/:id',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        props: true,
        component: () => import('@/views/breaking_news/EditBreakingNews.vue')
      }, // Just In news
      {
        name: 'just-in-news',
        path: '/just-in-news',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        props: true,
        component: () => import('@/views/just_in_news/ListJustInNews.vue')
      },
      {
        name: 'just-in-news-add',
        path: '/just-in-news/add',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        props: true,
        component: () => import('@/views/just_in_news/AddJustInNews.vue')
      },
      {
        name: 'just-in-news-edit',
        path: '/just-in-news/edit/:id',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        props: true,
        component: () => import('@/views/just_in_news/EditJustInNews.vue')
      },
      // pdfs
      {
        name: 'pdf-index',
        path: '/pdfs',
        meta: {
          requiresAuth: true,
          authorize: [roles.SUPER_ADMIN, roles.ADMIN]
        },
        props: true,
        component: () => import('@/views/pdfs/index.vue')
      }
    ]
  }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

export default routes
